// extracted by mini-css-extract-plugin
export default {"container":"WaUFpQdIhD","select":"ej84BjPZ5s","number":"vLrLqCxGD9","notification":"MBJTD9spK2"};